const UTILS = {
  async PromisesSequential(PromiseArr) {
    let res = []
    for (let i = 0; i < PromiseArr.length; i++) {
      res.push(await PromiseArr[i])
    }
    return res
  },
  ConvertStringToHTML(str) {
    let parser = new DOMParser()
    let doc = parser.parseFromString(str, 'text/html')
    return doc.body
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script")
    script.text = str
    document.head.appendChild(script).parentNode.removeChild(script)
  },
  ObserveIntersection(elementSelector, config, callback) {
    let observer = new IntersectionObserver(callback, config);
    let node = typeof elementSelector == 'string' ? document.querySelector(elementSelector) : elementSelector
    observer.observe(node, config);  
    return observer;
  },
  async AddItemsToCart(items_to_add, sections) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        items: items_to_add, 
        sections: sections 
      }),
    })
  }
};

